import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import ReadOnlyTextField from "../common/ReadOnlyTextField";

const styles = {
  operatorBox: {
    display: "flex",
    width: "56px",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "30px",
    height: "56px",
    px: 2,
  },
};

function formatCurrency(amount) {
  const num = typeof amount === "number" ? amount : parseFloat(amount) || 0;
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(num);
}

function formatNumber(value) {
  const num = typeof value === "number" ? value : parseFloat(value) || 0;
  return new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(num);
}

function formatWeight(value) {
  const num = typeof value === "number" ? value : parseFloat(value) || 0;
  const weightInLbs = num * 100;
  return `${new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(weightInLbs)} lbs`;
}

export default function ChargeCalculationRow({ label, rateUsed, quantity, total, notes, isHundredweight = false }) {
  return (
    <Box>
      {label && (
        <Typography variant="body2" sx={{ mb: 2, fontWeight: 500 }}>
          {label}
          {notes && (
            <Typography
              component="span"
              variant="body2"
              sx={{ fontWeight: 400, color: "text.secondary", ml: 1 }}
            >
              ({notes})
            </Typography>
          )}
        </Typography>
      )}
      <Box display="flex" alignItems="center">
        <ReadOnlyTextField value={formatCurrency(rateUsed)} label="Rate Used" />
        <Box sx={styles.operatorBox}>
          <CloseIcon />
        </Box>
        <ReadOnlyTextField 
          value={isHundredweight ? formatWeight(quantity) : formatNumber(quantity)} 
          label="Quantity" 
        />
        <Box sx={styles.operatorBox}>
          <DragHandleIcon />
        </Box>
        <ReadOnlyTextField value={formatCurrency(total)} label="Total" />
      </Box>
    </Box>
  );
}
